import type { Biomarker } from '../types/platform';

export interface Grade {
  grade: string;
  min: number;
  label: string;
  color: string;
}

export const gradeScale: Grade[] = [
  { grade: 'A+', min: 97, label: 'Exceptional', color: '#8fd3b0' },
  { grade: 'A', min: 92, label: 'Excellent', color: '#8fd3b0' },
  { grade: 'B+', min: 86, label: 'Very good', color: '#6fc3d3' },
  { grade: 'B', min: 80, label: 'Good', color: '#6fc3d3' },
  { grade: 'C+', min: 72, label: 'Fair', color: '#f5b454' },
  { grade: 'C', min: 62, label: 'Needs work', color: '#f5b454' },
  { grade: 'D', min: 0, label: 'Needs attention', color: '#f0788c' },
];

export function markerScore(b: Biomarker): number {
  if (b.value >= b.min && b.value <= b.max) return 100;
  const span = b.max - b.min || 1;
  const distance = b.value < b.min ? b.min - b.value : b.value - b.max;
  return Math.max(0, 60 - (distance / span) * 100);
}

export function panelScore(markers: Biomarker[]): number {
  if (markers.length === 0) return 100;
  return Math.round(markers.reduce((sum, b) => sum + markerScore(b), 0) / markers.length);
}

export function gradeFor(score: number): Grade {
  return gradeScale.find((g) => score >= g.min) ?? gradeScale[gradeScale.length - 1];
}
